// extracted by mini-css-extract-plugin
export default {"wrapper":"yhU2XI3mLDsOWIGGkwc_"};